import { useState, useEffect, useRef } from 'react'
import GlobalStyle from "./common.styled"

import Nav from "./sections/Nav";
import Hero from "./sections/Hero";
import About from "./sections/About";
import Skills from "./sections/Skills";
import Work from "./sections/Work"
import Projects from "./sections/Projects"
import Contact from "./sections/Contact"
import Footer from "./sections/Footer"
import Reviews from "./sections/Reviews";
import Loader from "./sections/Loader";
import BackToTop from "./components/BackToTop";

import { LanguageProvider } from './containers/Language';

export default function App() {
  const [isLoaded, setIsLoaded] = useState(false)
  const cursor = useRef()
  const cursorCircle = useRef()

  useEffect(() => {
    setTimeout(() => {
      setIsLoaded(true)
    }, 2000)
  }, [])

  useEffect(() => {
    const cursor = document.querySelector(".cursor");
    const cursorBorder = document.querySelector(".cursor-circle");
    const cursorPos = { x: window.innerWidth / 2, y: window.innerHeight / 2 };
    const cursorBorderPos = { x: window.innerWidth / 2, y: window.innerHeight / 2 };

    document.addEventListener("mousemove", (e) => {
      cursorPos.x = e.clientX;
      cursorPos.y = e.clientY;
      
      cursor.style.transform = `translate(${e.clientX}px, ${e.clientY}px)`;
    });

    requestAnimationFrame(function loop() {
      const easting = 16;
      cursorBorderPos.x += (cursorPos.x - cursorBorderPos.x) / easting;
      cursorBorderPos.y += (cursorPos.y - cursorBorderPos.y) / easting;

      cursorBorder.style.transform = `translate(${cursorBorderPos.x}px, ${cursorBorderPos.y}px)`;
      requestAnimationFrame(loop);
    });

    document.querySelectorAll("a, button, input, textarea, .ham-icon, .navbar .no-number").forEach((item) => {
      item.addEventListener("mouseover", (e) => {
        cursorBorder.style.backgroundColor = "var(--green-tint)";
        cursorBorder.style.setProperty("--size", "30px");
        cursor.style.opacity = "0";
      });
      item.addEventListener("mouseout", (e) => {
        cursorBorder.style.backgroundColor = "unset";
        cursorBorder.style.setProperty("--size", "50px");
        cursor.style.opacity = "1";
      });
    });
  })

  return (
    <LanguageProvider>
      <GlobalStyle />
      <div className='page-container'>
        <div className={`page-content ${!isLoaded ? 'hide' : "show"}`}>
          <BackToTop />
          <Nav />
          <main id="main">
            <Hero />
            <About />
            <Skills />
            <Work />
            <Projects />
            <Reviews />
            <Contact />
          </main>
          <Footer />
        </div>
        <div
          ref={cursor}
          style={{
            transform:
              typeof window !== "undefined"
                ? `translate(${window.innerWidth / 2}px, ${window.innerHeight / 2}px)`
                : "translate(-50%, -50%)",
          }}
          className='cursor'
        ></div>
        <div
          ref={cursorCircle}
          style={{
            transform:
              typeof window !== "undefined"
                ? `translate(${window.innerWidth / 2}px, ${window.innerHeight / 2}px)`
                : "translate(-50%, -50%)",
          }}
          className='cursor-circle'
        ></div>
        <Loader />
      </div>
    </LanguageProvider>
  );
}